
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import TipsPopup from '@/components/tipsPopup/index.vue'
import {
  getLotteryActivityDtl,
  closeActivity,
  confirmActivity,
  confirmActivityAgain
} from '@/api/marketActivity'
import {
  statusTypeList,
  periodTypeList,
  limitTypeList,
  formatDate,
  formatDateTime
} from './../index'
import { handleFill } from '@/utils/util'
import moment from 'moment'

@Component({
  components: { TipsPopup }
})
class ActivityDetail extends Vue {
  @Getter companyId!: string
  handleFill = handleFill

  detailData: any = null

  confirmActivityTipsPopupHtmlContent = ''

  get statusList() {
    return statusTypeList.filter((item) => item.value)
  }

  // 状态图片路径
  get statusImgSrc() {
    const status = this.detailData?.status
    const statusItem = this.statusList.find((item) => item.value === Number(status))
    if (statusItem?.img) {
      return require(`@/assets/images/marketActivity/detail/status/${statusItem.img}`)
    }
    return ''
  }

  // 统计日期文本
  get statisticsTimeText() {
    const { statisticsStartTime = '', statisticsEndTime = '' } = this.detailData
    if (!statisticsStartTime || !statisticsEndTime) return '--'
    return `${formatDate(statisticsStartTime)} 至 ${formatDate(
      statisticsEndTime
    )}`
  }

  // 抽奖时间文本
  get lotteryTimeText() {
    const { lotteryStartTime = '', lotteryEndTime = '' } = this.detailData

    if (!lotteryStartTime || !lotteryEndTime) return '--'
    return `<div>${formatDateTime(lotteryStartTime)}
    至 </div><div>${formatDateTime(lotteryEndTime)}</div>`
  }

  // 自动生效状态文本
  get selfEffectText() {
    const { isSelfEffect = 0 } = this.detailData
    if (isSelfEffect === 1) {
      return '（自动生效已开启）'
    } else if (isSelfEffect === 0) {
      return '（自动生效未开启）'
    }
    return ''
  }

  // 获取周期类型标签
  get periodTypeLabel() {
    const { periodType = 1 } = this.detailData
    const item: any = periodTypeList.find((p) => p.value === Number(periodType))
    return item.label || '--'
  }

  created() {
    const { lotteryId } = this.$route.query
    // 获取抽奖活动详情
    if (lotteryId) {
      this.getLotteryActivityDtl(lotteryId)
    }
  }

  // 限制对象类型文本
  limitTypeText(type: number): string {
    const item = limitTypeList.find((l) => l.value === Number(type))
    return (item && item.label) || '--'
  }

  // 限制文本
  limitText(limit: any) {
    const typeText = this.limitTypeText(limit.limitType)
    return `${typeText}限制仅可抽奖${limit.limitPrizeName}，中奖率为${limit.limitWinRate}%`
  }

  // 获取抽奖活动详情
  getLotteryActivityDtl(lotteryId: string | string[]) {
    getLotteryActivityDtl({
      storeId: this.companyId,
      lotteryId
    })
      .then((res) => {
        this.detailData = res.data || {}
      })
      .catch(() => {
        this.$toast('获取活动详情失败')
      })
  }

  // 关闭活动
  onCloseActivity() {
    ;(this.$refs.closeActivityTipsPopupRef as any).showPopup()
  }

  onCloseActivityConfirm() {
    const { lotteryId } = this.$route.query
    closeActivity({
      storeId: this.companyId,
      lotteryId
    })
      .then(() => {
        this.$toast('关闭成功')
        // 刷新
        this.getLotteryActivityDtl(lotteryId)
      })
      .catch(() => {
        this.$toast('关闭失败')
      })
  }

  // 修改配置
  onEditConfig() {
    const { lotteryId } = this.$route.query
    this.$router.push({
      path: '/createMarketActivity',
      query: { lotteryId }
    })
  }

  // 查看配置
  onViewConfig() {
    const { lotteryId } = this.$route.query
    this.$router.push({
      path: '/marketActivityConfig',
      query: { lotteryId }
    })
  }

  // 查看活动数据
  onViewData() {
    const { lotteryId, activityName } = this.$route.query
    this.$router.push({
      path: '/activityDetail',
      query: {
        lotteryId,
        activityName,
        lotteryStartTime: moment(this.detailData.lotteryStartTime).format(
          'YYYY-MM-DD'
        ),
        lotteryEndTime: moment(this.detailData.lotteryEndTime).format(
          'YYYY-MM-DD'
        )
      }
    })
  }

  onConfirm() {
    const { lotteryId } = this.$route.query
    confirmActivity({
      storeId: this.companyId,
      lotteryId
    })
      .then((res) => {
        if (Number(res?.data) === 1) {
          this.confirmActivityTipsPopupHtmlContent = `<P>${
            res?.msg || '活动已超过开始时间，是否继续开展活动？'
          }</P>`
          ;(this.$refs.confirmActivityTipsPopupRef as any).showPopup()
        } else {
          this.$toast('确认成功')
          // 刷新
          this.getLotteryActivityDtl(lotteryId)
        }
      })
      .catch(() => {
        this.$toast('确认失败')
      })
  }

  // 二次确认
  onConfirmActivityTipsCallback(isConfirm: number) {
    const { lotteryId } = this.$route.query
    const isConfirmText = isConfirm === 1 ? '确认' : '取消'
    confirmActivityAgain({
      storeId: this.companyId,
      lotteryId,
      isConfirm // 1确认 0取消
    })
      .then(() => {
        this.$toast(`${isConfirmText}成功`)
        // 刷新
        this.getLotteryActivityDtl(lotteryId)
      })
      .catch(() => {
        this.$toast(`${isConfirmText}失败`)
      })
  }
}
export default ActivityDetail
